var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79496 1.19502C8.06834 0.921646 8.06834 0.478412 7.79496 0.205034C7.52158 -0.0683446 7.07835 -0.0683446 6.80497 0.205034L4 3.01L1.19503 0.205034C0.921655 -0.068344 0.478421 -0.0683443 0.205042 0.205034C-0.0683359 0.478413 -0.0683357 0.921647 0.205042 1.19503L3.01001 4L0.205034 6.80497C-0.0683444 7.07835 -0.0683447 7.52159 0.205034 7.79496C0.478412 8.06834 0.921646 8.06834 1.19502 7.79496L4 4.98999L6.80498 7.79497C7.07835 8.06834 7.52159 8.06834 7.79497 7.79497C8.06834 7.52159 8.06834 7.07835 7.79497 6.80498L4.98999 4L7.79496 1.19502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4830ac600ee6732d11469fb9e506252f.svg";
export { ForwardRef as ReactComponent };